import React from 'react';
import GOT from '../utils/GOT';
import GOTUtil from '../utils/GOTUtil';
import QueryUtil from '../utils/QueryUtil';

import StringUtil from '../utils/StringUtil';
import RecordsUtil from '../utils/RecordsUtil';
import AjaxRemoteUtil from '../utils/AjaxRemoteUtil';
import FormResourceUtil from '../utils/FormResourceUtil';

import FormLookupRenderFactory from '../utils/FormLookupRenderFactory';
import FormItemConst from '../formItem/FormItemConst';
import LookupRefreshStore from '../stores/LookupRefreshStore';
import {LookupasteriskRefreshStore} from '../stores/LookupStores';
import {RecordsCmpStore,GroupCurrentRecordChangedStore} from '../stores/RecordsStore';
import FormDataSources from '../datasource/FormDataSources';
import {LookupHostKeydownStore} from '../stores/LookupStores';
import LookupActions from '../actions/LookupActions';
import FormLookupFactory from '../utils/FormLookupFactory';
import GOTPropertiesUtil from '../utils/GOTPropertiesUtil';
import CommonUtil from '../utils/CommonUtil';





const ReactDataGrid = require('react-data-grid');

class FormLookupServerSpec extends React.Component
{
	  constructor(props) 
	  {
	  	super(props);
	  	this.entityId = this.props.entityId;
	  	this.innerId = this.props.innerId;
	  	this.lookupKey = this.entityId+"."+this.innerId;
	  	this.classAlias = "FormLookup";
	  	
	  	this._extralsWhereItemsRefresh = null;
	  	this.queryBoxClear = this.queryBoxClear.bind(this);
	  	this.unsubscribeLookupCmpStore = 
			LookupRefreshStore.listen(this.onDataProviderRefresh.bind(this));
		this.unsubscribeLookupasteriskRefreshStore = 
			LookupasteriskRefreshStore.listen(this.onAsteriskRefresh.bind(this));
		this.unsubscribeLookupHostKeydownStore = 
			LookupHostKeydownStore.listen(this.onLookupHostKeydown.bind(this));

		this.unsubscribeRecordsCmpStore = RecordsCmpStore.listen(this.onExecuteCmp.bind(this));

		this.dataType = this.props.dataType;
	  	var dataTypeRelation = this.dataType.DataTypeRelation;
	  	var mainTablePro = dataTypeRelation.Properties.Table;
	  	var mainTable = null;
		if(mainTablePro.hasOwnProperty("refentityid"))
		{
			mainTable = GOT.getTable(mainTablePro.refentityid);
		}

		var dataTypeRelationNormalItem = GOT.getDataTypeRelationNormalItem(dataTypeRelation);

		var dataTypeRelationFixed = GOT.getDataTypeRelationFixedItem(dataTypeRelation);

		this.dataTypeRelationNormalItem = dataTypeRelationNormalItem;
		this.dataTypeRelationFixed = dataTypeRelationFixed;
		this.dataTypeRelation = dataTypeRelation;
		this.mainTable = mainTable;
		this.returnField = this.getReturnField(dataTypeRelationNormalItem,mainTable);
		this.returnFields = this.props.formLookupRemote.returnFields;
		this.autoReturn = true;		
		
		var totalWidth = 0;var columns = [];
		for(let i = 0;i<this.props.formLookupRemote.columns.length;i++)
		{
			var column = this.props.formLookupRemote.columns[i];
			var tableField = GOT.getTableField(this.mainTable,column.dataField)
			var type = tableField.type;
			var name = tableField.name;
			var column = {};
			
			var _dataField = mainTable.name + "." + StringUtil.convertToFirstLowerCase(name);
			var _label = column.label?column.label:(tableField.hasOwnProperty("shortcut")?"快捷码":GOTUtil.getFinalValue(tableField,mainTable,"Label"));
			var render = FormLookupRenderFactory.getLookupRender(type,_dataField,mainTable.id,tableField.id);
			var displayLength = column.displayLength?column.displayLength:GOTUtil.getFinalValue(tableField,mainTable,"DisplayLength");
			var _width = column.width?column.width:(Number(displayLength) * FormItemConst.displayLength_EN+FormItemConst.displayLength_ENAddon);totalWidth+=_width;column.width = _width
			column.formatter = render;column.name = _label;column.key = _dataField;column.editable = false;column.resizable = true;
			columns.push(column);
			
		}
		
	    this._columns = columns;
	    this.formXML = JSON.parse(JSON.stringify(FormLookupFactory.formLookupXMLTemplate));
	    this.setFormDataSources();
	  	this.state = { rows:[], selectedIndexes: [], scrollmax:0 ,gridContainerWidth:totalWidth,updateMinHeight:-1,containerWidth100:false};
	  }

	  componentWillUnmount()
	  {
	  	this.unsubscribeLookupCmpStore();
	  	this.unsubscribeLookupasteriskRefreshStore();
	  	this.unsubscribeLookupHostKeydownStore();
	  	this.unsubscribeRecordsCmpStore();
	  	this.formDataSources.componentWillUnmount();
	  }

	  onExecuteCmp(data,groupAlias,group)
	  {
	    if(this.formDataSources.firstGroup == group)
	    {
	      this.setState({ rows:data,selectedIndexes:[0]});
	      // if(data && data.length>0)
	      // {
	      // 	this.grid.doOnSelect({rowIndex:0,idx:0,active:false});
      	// 	$(this.refs["datagridcontainer"+this.entityId+this.innerId]).find(".react-grid-Cell.row-selected")[0].focus();
	      // }
	    }
	  }

	  setFormDataSources()
	  {
	  	var formDataSource = this.formXML.FormDataSources.DataSources[0];
			
		var tablePro = formDataSource.Properties["Table"];
		tablePro.refentityid = this.mainTable.id;
		tablePro.Value = this.mainTable.name;
		//自动构建的下拉换面的别名就是表名 不存在关联表 肯定不会重复 其被用作后台查询的数据的键值
		//与dataGrid中列的dataField也是一致
		formDataSource.name = this.mainTable.name;
		this.formDataSources = new FormDataSources(this.formXML.FormDataSources,this,true);
	  }

	  getReturnField(dataTypeRelationNormalItem,mainTable)
	  {
		var fieldValue = dataTypeRelationNormalItem.Properties.Field.V;
		if(fieldValue=="")
		{
			throw new Error("miss FieldValue");
		}
		return mainTable.name + "." + fieldValue.substr(0,1).toLowerCase()+fieldValue.substr(1);
	  }

	 
	  rowGetter(i) {
	    return this.state.rows[i];
	  }

	  rowClick(index,record,proxy)
	  {
	  	//alert("点击");
	  	var datas = this.state.rows;
	  	var returnItem = datas[index];
	  	var returnValue = returnItem[this.returnField];
	  	LookupActions.lookupReturn(returnValue,this.props.entityId,this.props.innerId);
	  }

	  gridKeyDown(proxy)
  	  {
  	  	if(proxy!=null && proxy!=undefined && proxy.hasOwnProperty("nativeEvent"))
	    {
	      let ne = proxy["nativeEvent"];
	      if(ne.keyCode == 40 || ne.keyCode == 38)
	      {
	      	this.moveSelectVertical(ne.keyCode);
	      	return;
	        var newSelectIndexes = this.state.selectedIndexes;
	        if(newSelectIndexes.length == 0)
	        {
	          if(this.state.rows.length>0)
	          {
	            newSelectIndexes.push(0);
	          }
	        }
	        else
	        {
	          let lastIndex = newSelectIndexes[newSelectIndexes.length-1];
	          let newIndex = ne.keyCode==40?lastIndex+1:lastIndex-1;
	          let total = this.state.rows.length;
	          if(newIndex>=0&&newIndex<total)
	          {
	            newSelectIndexes = [newIndex];
	          }
	        }

	        this.setState({selectedIndexes:newSelectIndexes});
	        return true;
	      }
	      else if(ne.keyCode == 13)
	      {
	    	var datas = this.state.rows;
	    	if(!datas || datas.length==0)
	    		return;
	    	var index = 0;
	    	if(this.state.selectedIndexes && this.state.selectedIndexes.length>0)
	    		index = this.state.selectedIndexes[this.state.selectedIndexes.length-1];
		  	var returnItem = datas[index];
		  	var returnValue = returnItem[this.returnField];
		  	LookupActions.lookupReturn(returnValue,this.props.entityId,this.props.innerId);
	      }
	    }
  	  }

  	  scrolling(arg)
  	  {
  	  	try
  	  	{
  	  		if(this.scrollState && arg.scrollLeft!=this.scrollState.scrollLeft)
	        {
		      //是横向滚动条 不需要动态加载数据
		      this.scrollState.scrollLeft = arg.scrollLeft;
		      return;
	        }
		    console.log(arg);
		    var _divdom = arg.dom;
		    if(_divdom)
		    {
			  var scrollTop,maxScroll,minScroll=0;
			  scrollTop = _divdom.scrollTop;
		      maxScroll = _divdom.scrollHeight - _divdom.clientHeight;
	      	  console.log(scrollTop+"------------"+maxScroll);
		  	  if(scrollTop >= (maxScroll-2))
	      	  {
		          // var addrows = this.createRows(50,50);
		          // var rows = this.state.rows.slice();
		          // var newrows = rows.concat(addrows);
		          // this.setState({rows:newrows,scrollmax:0}); 
		          if(this.formDataSources.firstGroup)
		          {
		          	this.formDataSources.firstGroup.scrollEndNextPage();
		          }
		      }
		      else if(scrollTop <=0){
			  
		      }
		    }
  	  	}
  	  	catch(e)
  	  	{

  	  	}
	  }

	  addFilterField(group)
	  {
		if(this._extralsWhereItemsRefresh && this._extralsWhereItemsRefresh.length>0 && group.currentQuery)
		{
			if(this.dataTypeRelation)
			{
				var filterfieldPro = this.dataType.DataTypeRelation.Properties.FilterField;
				if(filterfieldPro.hasOwnProperty("refentityid"))
				{
					var queryWhere = group.currentQuery.QueryTable.QueryWhere;
					for(let i = 0;i<this._extralsWhereItemsRefresh.length;i++)
					{
						var queryWhereItemValue = this._extralsWhereItemsRefresh[i];
						var queryWhereItem = 
						{
							qname:"QueryWhereItem",name:"t",id:"",tag:"autoAppendForFormModuleLookup",
			               	Properties:
			               	{
				               	Field:{V:"",refentityid:"",refinnerid:""},Value:{V:""},AndOr:{V:"And"},LeftBracket:{V:"None"},
				                RightBracket:{V:"None"},Label:{V:""},Status:{V:"Hide"},Enabled:{V:true}
			                }
			    		};
						
						var fieldPro = queryWhereItem.Properties.Field;
						var valuePro = queryWhereItem.Properties.Value;
						
						fieldPro.refentityid = filterfieldPro.refentityid;
						fieldPro.refinnerid = filterfieldPro.refinnerid;
						fieldPro.V = filterfieldPro.V;
						
						valuePro.V = queryWhereItemValue;
						if(!queryWhere.Items)queryWhere.Items = [];
						queryWhere.Items.push(queryWhereItem);
					}
				}
			}
		}
	  }

	  doDataProviderRefresh(arg)
	  {
	  	var group = this.formDataSources.firstGroup;
		if(!group)
		{
			var firstDataSourceName = this.formDataSources.xml.DataSources[0].name;
			group = this.formDataSources.groups[firstDataSourceName];
		}
		if(group)
		{
			group.reSetCurrentQuery();
			this.addFilterField(group);
			group.executeQueryAutoSaveStop(null,null,false,false,false,arg);
			//this.executeQuery(group);
		}
		else
		{
			throw new Error("FormModuleLookup refresh not find group");
		}
	  }

	  onDataProviderRefresh(entityId,innerId)
	  {
	  	if(this.entityId!=entityId || this.innerId != innerId)
	  		return;
	  	this.doDataProviderRefresh();
	  }

	  rpcDataProviderRefresh(formDataSourceGroupResult)
	  {
	  	var finalDatas = RecordsUtil.getOneLevelDatas(formDataSourceGroupResult,this.mainTable.name);
      	this.setState({ rows:finalDatas, selectedIndexes: [0], scrollmax:0 });
	  }

	  onAsteriskRefresh(entityId,innerId,filter)
	  {
	  	if(this.entityId != entityId || this.innerId != innerId)
	  		return;
	  	this.lookupArg["baseFilter"] = filter;
	  	this.doDataProviderRefresh({appendFilter:true});
	  }

	 

	  queryBoxClear()
	  {

	  }

	  setExtralWhereItemValueForRefresh(append=false,...params)
	  {
		if(append == true)
		{
			if(this._extralsWhereItemsRefresh == null)
				this._extralsWhereItemsRefresh = [];
		}
		else
		{
			this._extralsWhereItemsRefresh = [];	
		}
		
		for(var i in params)
		{
			var item = params[i];
			this._extralsWhereItemsRefresh.push(item);
		}
	  }

	  onLookupHostKeydown(lookupKey,e)
	  {
	  	if(this.props.lookupKey == lookupKey)
	  	{
	  		this.moveSelectVertical(e.keyCode);
	  		let methodName = 'onPress' + e.key;
	  		if (typeof this.grid[methodName] === 'function') {
		      this.grid[methodName](e);
		    }
	  	}
	  }

	  moveSelectVertical(keyCode)
	  {
	  	if(keyCode == 40 || keyCode == 38)
      	{
	        let record = null;
	        var newSelectIndexes = this.state.selectedIndexes;
	        if(newSelectIndexes.length == 0)
	        {
	          if(this.state.rows.length>0)
	          {
	            record = keyCode == 40?this.state.rows[0]:this.state.rows[this.state.rows.length-1];
	            newSelectIndexes.push(0);
	          }
	        }
	        else
	        {
	          let lastIndex = newSelectIndexes[newSelectIndexes.length-1];
	          let newIndex = keyCode==40?lastIndex+1:lastIndex-1;
	          let total = this.state.rows.length;
	          if(newIndex>=0&&newIndex<total)
	          {
	            record = this.state.rows[newIndex];
	            newSelectIndexes = [newIndex];
	          }
	        }
	        var selected = this.grid.state.selected;
	        var colIndex = 0;
	        if(selected)
	        	colIndex = selected.idx;
	        var rowIndex = (newSelectIndexes&&newSelectIndexes.length>0)?newSelectIndexes[0]:0;
	        this.setState({selectedIndexes:newSelectIndexes});
        	
        	this.grid.doOnSelect({rowIndex:rowIndex,idx:colIndex,active:false});	
	       	$(this.refs["datagridcontainer"+this.entityId+this.innerId]).find(".react-grid-Row.row-selected>.react-grid-Cell.row-selected")[colIndex].focus();
	        console.log("rowIndex:"+rowIndex+"   newSelectIndexes"+JSON.stringify(newSelectIndexes));
	        //this.grid.doOnSelect({idx:idx,rowIdx:rowIdx,active:false});

    	}
	  }

	  componentDidMount()
	  {
	  	//alert(this.entityId+" "+this.innerId);
		for(var key in this.formDataSources.groups)
		{
			var group = this.formDataSources.groups[key];
			group.initFormQuery();
			
		}
		//根据dataTypeRelationItem中的Fixed，补充QueryWhereItem
		this.addFixedWhereItem();
		this.addSysActiveWhereItem();
		this.addshortcutWhereItem();
	  }

	  addshortcutWhereItem()
	  {
		var shortcutfield = GOTUtil.getShortCut(this.mainTable);
		if(shortcutfield != null)
		{
			var group = this.formDataSources.firstGroup;
			var queryWhere = group.formQuery.QueryWhere;
			if(!queryWhere.Items)queryWhere.Items = [];
			var queryWhereItem = 
			{
				qname:"QueryWhereItem",name:"t",id:"",tag:"autoAppendForFormModuleLookup",
               	Properties:
               	{
	               	Field:{V:"",refentityid:"",refinnerid:""},Value:{V:""},AndOr:{V:"And"},LeftBracket:{V:"None"},
	                RightBracket:{V:"None"},Label:{V:""},Status:{V:"Hide"},Enabled:{V:true}
                }
    		};
			queryWhereItem.tag = "shortcut";
			var fieldPro = queryWhereItem.Properties.Field;
			var valuePro = queryWhereItem.Properties.Value;
			
			fieldPro.refentityid = mainTable.id;
			fieldPro.refinnerid = shortcutfield.id;
			fieldPro.V = shortcutfield.name;
			
			valuePro.Value = "";
			
			queryWhere.Items.push(queryWhereItem);
		}
	  }
	
	  addSysActiveWhereItem()
	  {
		if(!this.formDataSources)
			throw new Error("formDataSources");
		var group = this.formDataSources.firstGroup;
		if(group.formQuery)
		{	
			var dataType = this.dataType;
			var sysactivePro = dataType.Properties.SysActive || dataType.Properties.FilterSysActive;
			if(!sysactivePro)
				return;
			var queryWhere = null;var queryWhereItem;var fieldPro;var valuePro;
			if(sysactivePro.V=="true" || sysactivePro.V==true)
			{
				var tableFields = this.mainTable.TableFields;

				for(let i = 0;i<tableFields.length;i++)
				{
					var tableField = tableFields[i];
					//暂时这样判断是继承系统SysActive
					if((tableField.name=="SysActive" || tableField.name=="Active") && GOTUtil.getPropertyValue(tableField, "Extends")=="SysActive")
					{
						if(queryWhere == null)
							queryWhere = group.formQuery.QueryTable.QueryWhere;
						queryWhereItem = 
						{
							qname:"QueryWhereItem",name:"t",id:"",tag:"autoAppendForFormModuleLookup",
			               	Properties:
			               	{
				               	Field:{V:"",refentityid:"",refinnerid:""},Value:{V:""},AndOr:{V:"And"},LeftBracket:{V:"None"},
				                RightBracket:{V:"None"},Label:{V:""},Status:{V:"Hide"},Enabled:{V:true}
			                }
			    		};
						
						queryWhereItem.tag = "sysactive";
						fieldPro = queryWhereItem.Properties.Field;
						valuePro = queryWhereItem.Properties.Value;
						
						fieldPro.refentityid = this.mainTable.id;
						fieldPro.refinnerid = tableField.id;
						fieldPro.V = tableField.name;
						valuePro.V = true;
						if(!queryWhere.Items)queryWhere.Items = [];
						queryWhere.Items.push(queryWhereItem);
						break;
					}
				}
			}
		}
	  }
	
	  addFixedWhereItem()
	  {
		if(!this.formDataSources)
			throw new Error("formDataSources");
		var group = this.formDataSources.firstGroup;
		if(group.formQuery)
		{
			if(this.dataTypeRelationFixedItems && dataTypeRelationFixedItems.length() > 0)
			{
				var queryWhere = group.formQuery.QueryWhere;
				var queryWhereItem;var fieldPro;var valuePro;var relationItemFieldPro;var relationItemValuePro;
				for(let i = 0;i<this.dataTypeRelationFixedItems.length;i++)
				{
					var dataTypeRelationFixedItem = this.dataTypeRelationFixedItems[i];
					queryWhereItem = 
					{
						qname:"QueryWhereItem",name:"t",id:"",tag:"autoAppendForFormModuleLookup",
		               	Properties:
		               	{
			               	Field:{V:"",refentityid:"",refinnerid:""},Value:{V:""},AndOr:{V:"And"},LeftBracket:{V:"None"},
			                RightBracket:{V:"None"},Label:{V:""},Status:{V:"Hide"},Enabled:{V:true}
		                }
		    		};
					queryWhereItem.tag = "fixed";
					fieldPro = queryWhereItem.Properties.Field;
					valuePro = queryWhereItem.Properties.Value;
					relationItemFieldPro = dataTypeRelationFixedItem.Properties.Field;
					relationItemValuePro = dataTypeRelationFixedItem.Properties.FixedValue;
					fieldPro.refentityid = relationItemFieldPro.refentityid;
					fieldPro.refinnerid = relationItemFieldPro.refinnerid;
					fieldPro.V = relationItemFieldPro.V;
					valuePro.V = relationItemValuePro.V;
					if(!queryWhere.Items)queryWhere.Items = [];
					queryWhere.Items.push(queryWhereItem);
				}
				var formQueryCopy = JSON.parse(JSON.stringify(group.formQuery));
				group.reSetCurrentQuery(formQueryCopy);
	
			}
			
		}
		
	  }

	  closeHandler()
	  {
	  	LookupActions.popDropDownClose(this.entityId,this.innerId);
	  }

	  getGridDom()
	  {
	  	return (
		    <div className={'datagridcontainer'} style={{width:(this.state.gridContainerWidth+40)+'px',height:'300px'}}
		    	 ref={"datagridcontainer"+this.entityId+this.innerId}>
		      	<ReactDataGrid
					ref={ node => this.grid = node }
		        	onRowClick={this.rowClick.bind(this)}
		       		onGridKeyDown={this.gridKeyDown.bind(this)}
					numColumn={false}
					columns={this._columns}
					enableCellSelect={true}
					rowGetter={this.rowGetter.bind(this)}
					rowsCount={this.state.rows.length}
		        	rowHeight={FormItemConst.DATAGRID_ROW_HEIGHT}
		        	headerRowHeight={FormItemConst.DATAGRID_HEADER_HEIGHT}
					onScroll={this.scrolling.bind(this)}
					minHeight={-1}
					containerWidth100={this.state.containerWidth100}
					rowSelection={{
		  				showCheckbox: false,
		  				enableShiftSelect: true,
		  				selectBy: {
		  				  indexes: this.state.selectedIndexes
		  				}
				  	}}
				/>
		    </div>
		  );
	  }

	
	 
	  render() 
	  {
	     let gridDom = this.getGridDom();	     
	     if(this.props.isPop)
	     {
     		return(<div style={{alignSelf:"center",border:"2px solid #e5e5e5",borderRadius:"2px"}}>
	              <div className="modal-header" style={{background:"#ffffff",padding:"5px",position:"relative",height:"30px"}}>
	              	<i className="fa fa-close" style={{position:"absolute",top:"7px",right:"10px",fontSize:"15px",cursor:"pointer"}} onClick={this.closeHandler.bind(this)}></i>
	              </div>
	              <div style={{width:'100px',height:'30px',backgroundColor:'#ff0000'}}></div>
	              {gridDom}
        	  </div>);	
	     	
	     }
	     else
	     {
	     	return gridDom;
	     }
	  }
};
FormLookupServerSpec.defaultProps = {
};

module.exports=FormLookupServerSpec;


// WEBPACK FOOTER //
// ./src/components/FormLookupServerSpec.js